import { getRecoil, setRecoil } from 'recoil-nexus';

import { runKey } from 'components/admin/pages/Imports/ImportRequests/lib/constants';

import { importProgressState } from './importProgressState';

// Ephemeral progress ticks from the worker (kind 'import-progress'):
// { runKind, runId, importRequestId, phase, done, total, message }. The legacy
// importInfoId/importId keys are still accepted, since an older worker build
// emits only those — and they also say which ledger the run belongs to, which is
// what the key needs when `runKind` is absent.
//
// Keyed by kind + id, never by id alone: `import_info` and `patient_imports`
// have independent sequences, so EHR #42 and CSV #42 would otherwise overwrite
// each other's progress. Out-of-order (lower `done`) ticks are ignored, since
// emits are not ordered.
export default (data) => {
  const {
    importInfoId,
    importId,
    runKind,
    runId,
    importRequestId,
    phase,
    done,
    total,
    counts,
    message
  } = data || {};
  const id = runId ?? importInfoId ?? importId;
  if (id === undefined || id === null) return;

  const kind =
    runKind ||
    (importInfoId !== undefined && importInfoId !== null
      ? 'ehr'
      : importId !== undefined && importId !== null
        ? 'csv'
        : undefined);
  const key = runKey({ kind, id });

  const prev = getRecoil(importProgressState);
  const prevEntry = prev[key];
  if (
    prevEntry &&
    typeof done === 'number' &&
    typeof prevEntry.done === 'number' &&
    done < prevEntry.done
  ) {
    return;
  }

  setRecoil(importProgressState, {
    ...prev,
    // `counts` is the run's tally so far (success/info/partial/duplicates/
    // errors/skipped). An older worker build sends none, so the last one seen is
    // kept rather than blanking the panel mid-run.
    [key]: {
      id,
      runKind: kind,
      importRequestId,
      phase,
      done,
      total,
      counts: counts || prevEntry?.counts || null,
      message
    }
  });
};
